import { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import styled from 'styled-components'

import PasswordChangeInputCodeModal from '~/shared/components/modals/auth/PasswordChangeInputCodeModal'
import PasswordChangeModal from '~/shared/components/modals/auth/PasswordChangeModal'
import PasswordResetModal from '~/shared/components/modals/auth/PasswordResetModal'
import SignInModal from '~/shared/components/modals/auth/SignInModal'
import SignUpModal from '~/shared/components/modals/auth/SignUpModal'
import CircleApplyCancelConfirmModal from '~/shared/components/modals/circle-apply/CircleApplyCancelConfirmModal'
import CircleApplyDeleteConfirmModal from '~/shared/components/modals/circle-apply/CircleApplyDeleteConfirmModal'
import CircleApplyDeletedModal from '~/shared/components/modals/circle-apply/CircleApplyDeletedModal'
import ScheduleModal from '~/shared/components/modals/main/ScheduleModal'
import ChangePasswordModal from '~/shared/components/modals/mypage/ChangePasswordModal'
import ModifyInfoModal from '~/shared/components/modals/mypage/ModifyInfoModal'
import NoRefundModal from '~/shared/components/modals/mypage/NoRefundModal'
import PaymentCancelCompletedModal from '~/shared/components/modals/mypage/PaymentCancelCompletedModal'
import PaymentCancelModal from '~/shared/components/modals/mypage/PaymentCancelModal'
import QrModal from '~/shared/components/modals/mypage/QrModal'
import TicketDetailModal from '~/shared/components/modals/ticket/TicketDetailModal'
import useBodyScrollLock from '~/shared/hooks/useBodyScrollLock'
import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'

const Modal = () => {
  const isModalOpen = useRecoilValue(isModalOpenState)
  const { lockScroll, openScroll } = useBodyScrollLock()

  useEffect(() => {
    if (isModalOpen.isOpen) {
      lockScroll()
    } else {
      openScroll()
    }

    return () => {
      openScroll()
    }
  }, [isModalOpen.isOpen, lockScroll, openScroll])

  return (
    <Wrapper>
      {isModalOpen.contents === 'sign-in' ? (
        <SignInModal />
      ) : isModalOpen.contents === 'sign-up' ? (
        <SignUpModal />
      ) : isModalOpen.contents === 'password-change' ? (
        <PasswordChangeModal />
      ) : isModalOpen.contents === 'password-reset' ? (
        <PasswordResetModal />
      ) : isModalOpen.contents === 'circle-apply-delete-confirm' ? (
        <CircleApplyDeleteConfirmModal />
      ) : isModalOpen.contents === 'circle-apply-cancel-confirm' ? (
        <CircleApplyCancelConfirmModal />
      ) : isModalOpen.contents === 'circle-apply-deleted' ? (
        <CircleApplyDeletedModal />
      ) : isModalOpen.contents === 'schedule' ? (
        <ScheduleModal />
      ) : isModalOpen.contents === 'ticket-detail' ? (
        <TicketDetailModal />
      ) : isModalOpen.contents === 'mypage-modify-info' ? (
        <ModifyInfoModal />
      ) : isModalOpen.contents === 'mypage-change-password' ? (
        <ChangePasswordModal />
      ) : isModalOpen.contents === 'mypage-qr' ? (
        <QrModal />
      ) : isModalOpen.contents === 'payment-cancel' ? (
        <PaymentCancelModal />
      ) : isModalOpen.contents === 'no-refund' ? (
        <NoRefundModal />
      ) : isModalOpen.contents === 'payment-cancel-completed' ? (
        <PaymentCancelCompletedModal />
      ) : isModalOpen.contents === 'password-change-input-code' ? (
        <PasswordChangeInputCodeModal />
      ) : (
        <></>
      )}
    </Wrapper>
  )
}

export default Modal

const Wrapper = styled.div`
  position: fixed;
  z-index: ${theme.zIndex.modal};
  inset: 0;
  background: rgb(0 0 0 / 70%);
`
